import api from "@/lib/api";
import type {
  Product,
  ProductCreate,
  ProductUpdate,
} from "@/types/products/api-types/product-types";
import type { PaginatedResponse } from "@/types/common/api-types";

export const productsApi = {
  getAll: async (params?: {
    page?: number;
    size?: number;
    name?: string;
    category_name?: string;
    brand_name?: string;
    active_only?: boolean;
  }): Promise<PaginatedResponse<Product>> => {
    const response = await api.get<PaginatedResponse<Product>>(
      "/products",
      { params }
    );
    return response.data;
  },

  getById: async (id: number): Promise<Product> => {
    const response = await api.get<Product>(`/products/${id}`);
    return response.data;
  },

  create: async (data: ProductCreate): Promise<Product> => {
    const response = await api.post<Product>("/products", data);
    return response.data;
  },

  update: async (id: number, data: ProductUpdate): Promise<Product> => {
    const response = await api.put<Product>(`/products/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/products/${id}`);
  },
};
